// extracted by mini-css-extract-plugin
export default {"control":"control-button_control__oOrpy"};